import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { Utils } from '../../Utils/Utils';
import { DateTimePickerApi } from '../../Widgets/DateTimePicker';
import { StatusMessageHelper } from '../../Utils/StatusMessageHelper';

export interface SetValidityPageOptions {
    urlList: string;
    urlDetail: string;
    urlPost: string;
}

class SetValidityRequest {
    public SetValidFrom: boolean;
    public SetValidTo: boolean;
    public ValidFrom: number | null;
    public ValidTo: number | null;
    public Ids: HTMLElement[];
    public Password: string;
    public Reason: string;
}

export class SetValidityPage extends PageBase<SetValidityPageOptions> {

    private _validFromCheckbox: HTMLInputElement;
    private _validToCheckbox: HTMLInputElement;

    private _validFrom: DateTimePickerApi;
    private _validTo: DateTimePickerApi;

    private _passwordInput: HTMLInputElement;
    private _reasonInput: HTMLInputElement;

    constructor(options: SetValidityPageOptions) {
        super(options);
        this.hideSetValidity = this.hideSetValidity.bind(this);
        this.setValidity = this.setValidity.bind(this);
    }

    init(): void {
        this._validFromCheckbox = document.getElementById("validFromCheckBox") as HTMLInputElement;
        this._validToCheckbox = document.getElementById("validToCheckBox") as HTMLInputElement;
        this._validFrom = new DateTimePickerApi("validFromValue");
        this._validTo = new DateTimePickerApi("validToValue");
        this._passwordInput = document.getElementById("edPasswordValidity") as HTMLInputElement;
        this._reasonInput = document.getElementById("edEditValidityReason") as HTMLInputElement;

        const btnCancel = Utils.getJQueryById("btnHideSetValidity");
        btnCancel.on("click", this.hideSetValidity);

        const btnSubmitValidity = Utils.getJQueryById("btnSubmitValidity");
        btnSubmitValidity.on("click", this.setValidity);
    }

    private hideSetValidity() {
        $('#validitySettings').attr("hidden", "hidden");
    }

    private setValidity(e: JQueryEventObject) {
        e.preventDefault();
        let urlPost = this._options.urlPost;
        let that = this;
        var ids = $("input[name='selectedConfig']:checked").map(function () {
            return $(this).val();
        });
        var statusMessage = Utils.getJQueryById("statusMessageWrapper");
        let checkAll = $("#selectAll");
        var table = Utils.getJQueryById('tableGameConfigurations').DataTable();
        let request = new SetValidityRequest();
        request.SetValidFrom = this._validFromCheckbox.checked;
        request.SetValidTo = this._validToCheckbox.checked;
        request.ValidFrom = this._validFrom.getUnixTimestamp();
        request.ValidTo = this._validTo.getUnixTimestamp();
        request.Password = this._passwordInput.value;
        request.Reason = this._reasonInput.value;
        request.Ids = ids.get();
        $.ajax({
            url: urlPost,
            type: "POST",
            dataType: 'html',
            data: { request: request },
            success: function (data) {
                checkAll.prop('checked', false);
                that.hideSetValidity();
                statusMessage.html(data);
                StatusMessageHelper.initValidator();
                StatusMessageHelper.initSatusMessage();
                table.draw();
            }
        });
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/GameConfigurations/SetValidityPage.ts
 **/